import React, { FC } from 'react';

import { Icon } from '@iconify/react';
import clsx from 'clsx';

import { LiveUserNotificationVariants } from '~/services/abTests/features';

import styles from './styles.module.scss';

type Props = {
  message: string;
  variant: LiveUserNotificationVariants;
};

const icons: Record<LiveUserNotificationVariants, string> = {
  [LiveUserNotificationVariants.INFO]: 'material-symbols:info-rounded',
  [LiveUserNotificationVariants.WARNING]: 'material-symbols:warning-rounded',
  [LiveUserNotificationVariants.ERROR]: 'material-symbols:error-rounded',
};

const NotificationBanner: FC<Props> = ({ message, variant }) => {
  return (
    <div className={clsx(styles.banner, styles[`banner--${variant}`])}>
      <Icon fontSize={24} icon={icons[variant]} />
      <span>{message}</span>
    </div>
  );
};

export default NotificationBanner;
